'use es6';

import { ALL_WORKFLOWS } from 'reference-resolvers/constants/CacheKeys';
import { getAllWorkflows, createGetAllWorkflows } from 'reference-resolvers/api/WorkflowsAPI';
import createSimpleCachedReferenceResolver from 'reference-resolvers/lib/createSimpleCachedReferenceResolver';
export const createAllWorkflowReferenceResolver = options => createSimpleCachedReferenceResolver(Object.assign({
  cacheKey: ALL_WORKFLOWS,
  createFetchData: createGetAllWorkflows,
  fetchData: getAllWorkflows
}, options));
export default createAllWorkflowReferenceResolver();